// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/AdminPelada.css */
/* Tokens (alinhados com dashboard.css) */
:root {
  --bg: #0b0d12;
  --card: #11141b;
  --card-2: #0f1218;
  --text: #e7edf6;
  --muted: #a6b0c3;
  --border: #1c2330;
  --brand: #22c55e;
  --brand-2: #16a34a;
  --danger: #ef4444;
  --warning: #f59e0b;
  --info: #3b82f6;

  --radius: 16px;
  --radius-sm: 12px;
  --shadow: 0 8px 24px rgba(0,0,0,0.35);
  --shadow-soft: 0 6px 18px rgba(0,0,0,0.25);

  --gap: 16px;
  --gap-lg: 24px;

  --menu-h: 72px;
}

* { box-sizing: border-box; }
html, body, #root { height: 100%; }
html, body {
  width: 100%;
  overflow-x: hidden; /* evita rolagem lateral */
  -webkit-text-size-adjust: 100%;
}
img, svg, video { max-width: 100%; height: auto; }

body {
  background: linear-gradient(180deg, #0a0c10 0%, #0b0d12 100%);
  color: var(--text);
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Inter, "Helvetica Neue", Arial, "Noto Sans";
}

/* Header fixo (vindo do Menu) */
.topbar {
  position: fixed;
  top: 0; left: 0; right: 0;
  height: var(--menu-h);
  z-index: 60;
  background: var(--bg);
  border-bottom: 1px solid var(--border);
  display: grid;
  align-items: center;
}

/* Página */
.admin-page {
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr;
  padding-top: calc(var(--menu-h) + env(safe-area-inset-top));
}

/* Conteúdo principal */
.admin-content {
  padding: 16px clamp(12px, 4vw, 32px);
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

/* Header da página (título + ações) */
.admin-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--gap);
  flex-wrap: wrap;       /* quebra no mobile */
  margin-bottom: 24px;
  min-width: 0;
}
.admin-title {
  margin: 0;
  font-size: clamp(20px, 4vw, 28px);
  font-weight: 800;
  letter-spacing: .2px;
}
.admin-subtitle {
  margin: 4px 0 0 0;
  color: var(--muted);
  font-size: 14px;
}
.admin-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* Grid de seções (cards) */
.admin-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--gap-lg);
  min-width: 0;
}
@media (min-width: 980px) {
  .admin-grid { grid-template-columns: 1fr 1fr; }
}

/* Card padrão */
.admin-card {
  background: linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;
  box-shadow: var(--shadow);
  min-width: 0;
}
.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 10px;
}
.card-head h2 {
  margin: 0;
  font-size: 18px;
  letter-spacing: .2px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.card-body {
  min-width: 0;
}

/* Botões */
.btn {
  border: 1px solid var(--border);
  background: #0c0f14;
  color: var(--text);
  padding: 10px 12px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all .2s ease;
}
.btn:hover { transform: translateY(-1px); box-shadow: var(--shadow-soft); }
.btn--ghost {
  background: transparent;
  border: 1px solid var(--border);
}
.btn--primary {
  background: linear-gradient(180deg, var(--brand) 0%, var(--brand-2) 100%);
  border: none;
  color: #041107;
}
.btn--danger {
  background: linear-gradient(180deg, var(--danger), #c23b3b);
  border: none;
  color: #fff;
}

/* Loader */
.loader-overlay {
  position: fixed; inset: 0;
  background: rgba(6, 8, 12, 0.6);
  backdrop-filter: blur(3px);
  display: grid; place-items: center;
  z-index: 80;
}
.loader-spinner {
  width: 44px; height: 44px; border-radius: 999px;
  border: 3px solid #1f2937; border-top-color: var(--brand);
  animation: spin 1s linear infinite; margin-bottom: 10px;
}
.loader-text { text-align: center; color: var(--muted); }
@keyframes spin { to { transform: rotate(360deg); } }

/* Modal */
.modal-backdrop {
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.55);
  display: grid; place-items: center;
  z-index: 90;
  padding: 16px;
}
.modal {
  width: 100%;
  max-width: 420px;
  background: linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: 0 12px 36px rgba(0,0,0,0.45);
  padding: 18px;
}
.modal h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 800;
}
.modal p {
  margin: 0 0 16px 0;
  color: var(--muted);
}
.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

/* Erros */
.error-message {
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #fecaca;
  padding: 12px 14px;
  border-radius: var(--radius-sm);
  margin-top: 16px;
}

/* Ajustes micro para telas estreitas */
@media (max-width: 380px) {
  .btn { padding: 9px 10px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AdminPelada.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B,yCAAyC;AACzC;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;;EAEf,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,0CAA0C;;EAE1C,WAAW;EACX,cAAc;;EAEd,cAAc;AAChB;;AAEA,IAAI,sBAAsB,EAAE;AAC5B,oBAAoB,YAAY,EAAE;AAClC;EACE,WAAW;EACX,kBAAkB,EAAE,0BAA0B;EAC9C,8BAA8B;AAChC;AACA,kBAAkB,eAAe,EAAE,YAAY,EAAE;;AAEjD;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,mHAAmH;AACrH;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,qBAAqB;EACrB,WAAW;EACX,qBAAqB;EACrB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,aAAa;EACb,4BAA4B;EAC5B,2DAA2D;AAC7D;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,eAAe,QAAQ,qBAAqB;EAC5C,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,SAAS;EACT,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,cAAc,8BAA8B,EAAE;AAChD;;AAEA,gBAAgB;AAChB;EACE,uEAAuE;EACvE,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;;AAEA,WAAW;AACX;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;AACA,aAAa,2BAA2B,EAAE,8BAA8B,EAAE;AAC1E;EACE,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,yEAAyE;EACzE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,2DAA2D;EAC3D,YAAY;EACZ,WAAW;AACb;;AAEA,WAAW;AACX;EACE,eAAe,EAAE,QAAQ;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa,EAAE,mBAAmB;EAClC,WAAW;AACb;AACA;EACE,WAAW,EAAE,YAAY,EAAE,oBAAoB;EAC/C,yBAAyB,EAAE,8BAA8B;EACzD,kCAAkC,EAAE,mBAAmB;AACzD;AACA,eAAe,kBAAkB,EAAE,mBAAmB,EAAE;AACxD,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,UAAU;AACV;EACE,eAAe,EAAE,QAAQ;EACzB,4BAA4B;EAC5B,aAAa,EAAE,mBAAmB;EAClC,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,uEAAuE;EACvE,+BAA+B;EAC/B,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,OAAO,iBAAiB,EAAE;AAC5B","sourcesContent":["/* src/pages/AdminPelada.css */\n/* Tokens (alinhados com dashboard.css) */\n:root {\n  --bg: #0b0d12;\n  --card: #11141b;\n  --card-2: #0f1218;\n  --text: #e7edf6;\n  --muted: #a6b0c3;\n  --border: #1c2330;\n  --brand: #22c55e;\n  --brand-2: #16a34a;\n  --danger: #ef4444;\n  --warning: #f59e0b;\n  --info: #3b82f6;\n\n  --radius: 16px;\n  --radius-sm: 12px;\n  --shadow: 0 8px 24px rgba(0,0,0,0.35);\n  --shadow-soft: 0 6px 18px rgba(0,0,0,0.25);\n\n  --gap: 16px;\n  --gap-lg: 24px;\n\n  --menu-h: 72px;\n}\n\n* { box-sizing: border-box; }\nhtml, body, #root { height: 100%; }\nhtml, body {\n  width: 100%;\n  overflow-x: hidden; /* evita rolagem lateral */\n  -webkit-text-size-adjust: 100%;\n}\nimg, svg, video { max-width: 100%; height: auto; }\n\nbody {\n  background: linear-gradient(180deg, #0a0c10 0%, #0b0d12 100%);\n  color: var(--text);\n  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Inter, \"Helvetica Neue\", Arial, \"Noto Sans\";\n}\n\n/* Header fixo (vindo do Menu) */\n.topbar {\n  position: fixed;\n  top: 0; left: 0; right: 0;\n  height: var(--menu-h);\n  z-index: 60;\n  background: var(--bg);\n  border-bottom: 1px solid var(--border);\n  display: grid;\n  align-items: center;\n}\n\n/* Página */\n.admin-page {\n  min-height: 100vh;\n  display: grid;\n  grid-template-rows: auto 1fr;\n  padding-top: calc(var(--menu-h) + env(safe-area-inset-top));\n}\n\n/* Conteúdo principal */\n.admin-content {\n  padding: 16px clamp(12px, 4vw, 32px);\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* Header da página (título + ações) */\n.admin-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--gap);\n  flex-wrap: wrap;       /* quebra no mobile */\n  margin-bottom: 24px;\n  min-width: 0;\n}\n.admin-title {\n  margin: 0;\n  font-size: clamp(20px, 4vw, 28px);\n  font-weight: 800;\n  letter-spacing: .2px;\n}\n.admin-subtitle {\n  margin: 4px 0 0 0;\n  color: var(--muted);\n  font-size: 14px;\n}\n.admin-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n/* Grid de seções (cards) */\n.admin-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--gap-lg);\n  min-width: 0;\n}\n@media (min-width: 980px) {\n  .admin-grid { grid-template-columns: 1fr 1fr; }\n}\n\n/* Card padrão */\n.admin-card {\n  background: linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 16px;\n  box-shadow: var(--shadow);\n  min-width: 0;\n}\n.card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  gap: 10px;\n}\n.card-head h2 {\n  margin: 0;\n  font-size: 18px;\n  letter-spacing: .2px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.card-body {\n  min-width: 0;\n}\n\n/* Botões */\n.btn {\n  border: 1px solid var(--border);\n  background: #0c0f14;\n  color: var(--text);\n  padding: 10px 12px;\n  border-radius: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all .2s ease;\n}\n.btn:hover { transform: translateY(-1px); box-shadow: var(--shadow-soft); }\n.btn--ghost {\n  background: transparent;\n  border: 1px solid var(--border);\n}\n.btn--primary {\n  background: linear-gradient(180deg, var(--brand) 0%, var(--brand-2) 100%);\n  border: none;\n  color: #041107;\n}\n.btn--danger {\n  background: linear-gradient(180deg, var(--danger), #c23b3b);\n  border: none;\n  color: #fff;\n}\n\n/* Loader */\n.loader-overlay {\n  position: fixed; inset: 0;\n  background: rgba(6, 8, 12, 0.6);\n  backdrop-filter: blur(3px);\n  display: grid; place-items: center;\n  z-index: 80;\n}\n.loader-spinner {\n  width: 44px; height: 44px; border-radius: 999px;\n  border: 3px solid #1f2937; border-top-color: var(--brand);\n  animation: spin 1s linear infinite; margin-bottom: 10px;\n}\n.loader-text { text-align: center; color: var(--muted); }\n@keyframes spin { to { transform: rotate(360deg); } }\n\n/* Modal */\n.modal-backdrop {\n  position: fixed; inset: 0;\n  background: rgba(0,0,0,0.55);\n  display: grid; place-items: center;\n  z-index: 90;\n  padding: 16px;\n}\n.modal {\n  width: 100%;\n  max-width: 420px;\n  background: linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  box-shadow: 0 12px 36px rgba(0,0,0,0.45);\n  padding: 18px;\n}\n.modal h3 {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  font-weight: 800;\n}\n.modal p {\n  margin: 0 0 16px 0;\n  color: var(--muted);\n}\n.modal-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n/* Erros */\n.error-message {\n  background: rgba(239, 68, 68, 0.15);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #fecaca;\n  padding: 12px 14px;\n  border-radius: var(--radius-sm);\n  margin-top: 16px;\n}\n\n/* Ajustes micro para telas estreitas */\n@media (max-width: 380px) {\n  .btn { padding: 9px 10px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
